import React from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { countryFlagEmoji, getLocalizedCountryName, isTurkeyCountry, normalizeCountryCode } from '@/lib/country-i18n';

export function getSellerCountryMeta(country) {
  const raw = (country || '').toString().trim();
  if (!raw) {
    return { code: null, isTR: false, missing: true };
  }
  const code = normalizeCountryCode(raw);
  return {
    code,
    isTR: isTurkeyCountry(raw),
    missing: false,
    raw,
  };
}

const SellerCountryBadge = ({ country, compact = false }) => {
  const { t, i18n } = useTranslation();
  const meta = getSellerCountryMeta(country);

  if (meta.missing) {
    return (
      <Badge variant="outline" className="text-muted-foreground font-normal">
        {t('admin.sellers.countryMissing')}
      </Badge>
    );
  }

  const flag = countryFlagEmoji(meta.code);
  const label = meta.code
    ? getLocalizedCountryName(meta.code, i18n.language, meta.raw)
    : meta.raw;

  return (
    <div className={`flex items-center gap-1.5 ${compact ? '' : 'flex-wrap'}`}>
      <span className="text-sm whitespace-nowrap">
        {flag ? `${flag} ` : ''}
        <span className="font-medium">{meta.code || meta.raw}</span>
        {!compact && label && label !== (meta.code || meta.raw) && (
          <span className="text-muted-foreground font-normal"> · {label}</span>
        )}
      </span>
      <Badge className={meta.isTR ? 'bg-red-600 hover:bg-red-600' : 'bg-blue-600 hover:bg-blue-600'}>
        {meta.isTR ? t('admin.sellers.turkishSeller') : t('admin.sellers.internationalSeller')}
      </Badge>
    </div>
  );
};

export default SellerCountryBadge;
